import Load from "../Assets/loading.gif";

const ProductCard = ({ product }) => {
  return (
    <div className="my-1 flex flex-col rounded-lg  overflow-hidden md:my-1 lg:my-2 xl:my-2  sm:shadow-lg sm:hover:shadow-2xl sm:w-[35vh]  lg:w-[40vh] sm:transition-shadow tracking-wide bg-gray-100 text-center h-min">
      <div className="relative w-full overflow-hidden  ">
        <div>
          <span className="flex animate-pulse absolute bg-blue-200 text-xs font-bold rounded-md top-2 left-2 px-5 py-3 z-10">
            {" "}
          </span>

          <div className="animate-pulse relative lg:h-[45vh] md:h-[40vh] sm:h-[35vh] pt-14">
            <img src={Load} alt="loading" />
          </div>
          <div className="animate-pulse rounded-md bg-gray-300 relative  py-3 w-[70%] mx-auto mb-1">
            {""}
          </div>
          <p className=" animate-pulse rounded-md bg-gray-300 my-1 py-3 text-xs sm:text-sm text-gray-500 truncate w-[80%] mx-auto">
            {""}
          </p>
        </div>
        <div className=" flex flex-col w-full">
          <div>
            <p className="flex flex-col justify-items-center font-bold text-base sm:text-xl mb-2 animate-pulse rounded-md bg-gray-300  px-5 py-3 w-[50%] mx-auto">
              {" "}
            </p>
          </div>
        </div>
        <button className=" rounded mt-2 p-2 w-full h-12 font-bold tracking-widest bg-gray-900 text-white hover:text-green-50 hover:bg-black focus:outline-none transition duration-500 ease-in-out transform hover:-translate-y-1 hover:scale-110">
          <div className="animate-pulse rounded-md  py-2 bg-gray-100 w-16 mx-auto">
            {" "}
            {""}
          </div>
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
